module.exports = __webpack_public_path__ + "static/img/act_rec@2x.png";